export const createTransactionDTO = () => ({
    project: null,
    sum: 0,
    datetime: new Date().toISOString(),
    comment: "",
    description: "",
    type: {value: null, display: ""},
    receipt: {text:"", file: null},
    expenseCode: {id: null, display: ""},
});
